import { ExternalLink, InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import { GithubIcon } from "@octopusdeploy/design-system-icons";
import { useRef } from "react";
import * as React from "react";
import { repository } from "~/clientInstance";
import { PortalEmptyStateOnboarding } from "~/components/GettingStarted/PortalEmptyStateOnboarding";
export const GitConnectionAuthorizeOnboarding = () => {
    const authorizeUrl = useRef(repository.GitHubApp.getAuthorizeAppUrl(window.location.href));
    const onboardingTextForGitHubAuthorize = "Clicking the button below will redirect you to GitHub. Continue to follow the prompts to connect Octopus to your GitHub account.";
    return (<PortalEmptyStateOnboarding title={"Connect Octopus and GitHub"} description={onboardingTextForGitHubAuthorize} actions={[
            {
                type: "button",
                buttonType: "secondary",
                icon: <GithubIcon size={16}/>,
                label: "Authorize the Octopus Deploy GitHub App",
                onClick: () => {
                    window.location.assign(authorizeUrl.current);
                },
            },
        ]} learnMore={<ExternalLink href={"GitHubApp"} label={"Learn More"}/>}/>);
};
export const GitConnectionInstallOnboarding = () => {
    const installUrl = useRef(repository.GitHubApp.getInstallationUrl(window.location.href));
    const onboardingTextForGitHubInstall = "Enable smooth and secure connectivity to GitHub by installing the Octopus Deploy GitHub App in your GitHub account.";
    return (<InlineEmptyStateOnboarding illustration={"EmptyState"} title="Configure the GitHub App" description={onboardingTextForGitHubInstall} actions={{
            external: {
                label: "Configure the Octopus Deploy GitHub App",
                onClick: () => {
                    window.location.assign(installUrl.current);
                },
            },
        }} learnMore={{ path: "GitHubApp", label: "Learn More" }}/>);
};
